/**
 * Handles parsing string based Oauth state into a POJO.
 *
 * @param {string} state Passed from Cognito to us in the URL
 */
export const parseCustomOauthState = state =>
  // Double decode since AWS will encode no matter what.  This prevents bugs where a % sign is first encoded to %2F,
  // then double encoded to something else.  This will break return URLs and redirects in the state.
  decodeURIComponent(state)
    .split('&')
    .map(kv => kv.split('='))
    .reduce((acc, x) => {
      acc[x[0].replace('?', '')] = x[1]
      return acc
    }, {})

/**
 * HACK: this is a function that is used during error flows, since Cognito
 * does not make the custom state visible during these.
 */
export const parseRawState = state => {
  try {
    const customState = state
      .split('-')
      .splice(1)
      .join('-')

    return customState
      .match(/.{2}/g)
      .map(function(char) {
        return String.fromCharCode(parseInt(char, 16))
      })
      .join('')
  } catch (e) {
    return ''
  }
}
